import { getData, saveData, destroyData } from './saveDataToLocal';

const EMPLOYEE_INFO_KEY = 'employee_info';

/**
 * Lấy thông tin người dùng hiện tại từ localStorage
 * @returns {Object|null}
 */
export const getCurrentUser = () => {
  const userDataString = getData(EMPLOYEE_INFO_KEY);
  if (!userDataString) {
    return null;
  }

  try {
    return JSON.parse(userDataString);
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    return null;
  }
};

/**
 * Save current user information to localStorage
 * @param {Object} userData - The user data to save
 */
export const saveCurrentUser = (userData) => {
  if (!userData) {
    return;
  }

  try {
    const userDataString = JSON.stringify(userData);
    saveData(EMPLOYEE_INFO_KEY, userDataString);
  } catch (error) {
    console.error('Error saving user data to localStorage:', error);
  }
};

/**
 * Kiểm tra xem người dùng đã đăng nhập hay chưa
 * @returns {boolean} True nếu người dùng đã đăng nhập, ngược lại false
 */
export const isUserLoggedIn = () => {
  return !!getCurrentUser();
};

/**
 * Lấy thông tin người dùng hiện tại
 * @param {string} property - [id, email, mobile, fullName, jobTitleId, storeId, storeName]
 * @returns {any} The property value or undefined if not found
 */
export const getUserProperty = (property) => {
  const user = getCurrentUser();
  return user ? user[property] : undefined;
};

/**
 * Xóa thông tin người dùng hiện tại
 */
export const clearCurrentUser = () => {
  destroyData(EMPLOYEE_INFO_KEY);
};

export default {
  getCurrentUser,
  saveCurrentUser,
  isUserLoggedIn,
  getUserProperty,
  clearCurrentUser,
};
